import styled from "@emotion/styled";
import {
  TableBody,
  tableBodyClasses,
  TableHead,
  tableHeadClasses,
  tableRowClasses,
} from "@mui/material";

export const TableHeadStyled = styled(TableHead)(() => ({
  backgroundColor: "#EAEAF1",
  [`&.${tableHeadClasses.root} tr:nth-of-type(1)`]: {
    [`&.${tableRowClasses.root} th:nth-of-type(1)`]: {
      borderTopLeftRadius: "8px",
    },
    [`&.${tableRowClasses.root} th:last-child`]: {
      borderTopRightRadius: "8px",
    },
  },
}));

type TableBodyStripedRowsProps = {
  disableStripes: boolean;
  disableRowClick: boolean;
};

export const TableBodyStripedRows = styled(TableBody, {
  shouldForwardProp: (prop) =>
    prop !== "disableStripes" && prop !== "disableRowClick",
})<TableBodyStripedRowsProps>(({ disableStripes, disableRowClick }) => ({
  "& > tr": {
    cursor: disableRowClick ? "auto" : "pointer",
  },
  ...(!disableStripes && {
    "& > *:nth-of-type(even)": {
      backgroundColor: "#FAFAFB",
    },
  }),
  [`&.${tableBodyClasses.root} a`]: {
    [`&.${tableRowClasses.root} td`]: {
      border: "none",
    },
  },
  [`&.${tableBodyClasses.root} tr`]: {
    [`&.${tableRowClasses.root} td`]: {
      border: "none",
    },
  },
}));
